'use client'
import * as React from 'react'

import { useFormatTimeSpan } from '@web/app/[locale]/(web)/masterfeed/_hooks/use-format-time-span'

export function TimeCreated({ createTime }: { createTime: Date | string | null }) {
  const formatTimeSpan = useFormatTimeSpan()
  const timeElapsed = React.useMemo(
    () => createTime && formatTimeSpan(new Date().getTime() - new Date(createTime).getTime()),
    [createTime, formatTimeSpan],
  )
  return <span className="text-12 text-cf-grey-600">{timeElapsed}</span>
}
